// src/pages/AboutPage.jsx
import '../styles/App.css';
import '../styles/About.css';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import ComingSoon from '../components/ComingSoon';
import {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

function AboutPage() {
    const { t, i18n } = useTranslation();
    const [threePhones1Url, setThreePhones1Url] = useState('About-3-phones-01.png'
    );
    const [interface4, setInterface4] = useState('About-interface.png'
    );
    useEffect(() => {
        const updateSize = () => {
            if (window.innerWidth < 768) {
                setThreePhones1Url("About-3-phones-01-mob.png");
                setInterface4("About-interface-mob.png");
            } else {
                setThreePhones1Url("About-3-phones-01.png");
                setInterface4("About-interface.png");
            }
        };
        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    return (
        <>
            <Navbar />
            <div className="about-banner-01" />
            <div className="about-banner-02">
                <div className="banner-content">
                    <div className="row align-items-center g-0 h-100">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <img
                                src={`/Images/banners/${threePhones1Url}`}
                                alt="Banner 2"
                                className="img-fluid w-100"
                            />
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="about-container">
                                <h2>{t('about.title')}</h2>
                                <p>{t('about.description')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-banner-03">
                <div className="banner-content">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-7 text-center text-lg-start">
                                <div className="custom-text-box">
                                    <h2>{t('about.banner3.title')}</h2>
                                    <div className="two-by-two-grid">
                                        <div className="about-text-desc">
                                            <div className="about-text-desc-header">
                                                <img alt="" src="/Images/About-Sign-01.png" />
                                                <h3>{t('about.banner3.first.title')}</h3>
                                            </div>
                                            <p>{t('about.banner3.first.description')}</p>
                                        </div>
                                        <div className="about-text-desc">
                                            <div className="about-text-desc-header">
                                                <img alt="" src="/Images/About-Sign-02.png" />
                                                <h3>{t('about.banner3.second.title')}</h3>
                                            </div>
                                            <p>{t('about.banner3.second.description')}</p>
                                        </div>
                                        <div className="about-text-desc">
                                            <div className="about-text-desc-header">
                                                <img alt="" src="/Images/About-Sign-03.png" />
                                                <h3>{t('about.banner3.third.title')}</h3>
                                            </div>
                                            <p>{t('about.banner3.third.description')}</p>
                                        </div>
                                        <div className="about-text-desc">
                                            <div className="about-text-desc-header">
                                                <img alt="" src="/Images/About-Sign-04.png" />
                                                <h3>{t('about.banner3.fourth.title')}</h3>
                                            </div>
                                            <p>{t('about.banner3.fourth.description')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 text-center">
                                <img
                                    src="/Images/banners/About-3-phones-02.png"
                                    alt="3 Phones"
                                    className="img-fluid w-100"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-banner-04">
                <div className="banner-content">
                    <div className="row align-items-center g-0 h-100">
                        <div className="col-lg-6 order-1 order-lg-1 text-center text-lg-start">
                            <div className="about-container container">
                                <h2>{t('about.banner4.title')}</h2>
                                <p>{t('about.banner4.description1')}</p>
                                <p>{t('about.banner4.description2')}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-2 order-lg-2 mb-lg-0">
                            <img
                                src={`/Images/banners/${interface4}`}
                                alt="Banner 4"
                                className="img-fluid w-100"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-banner-05">
                <div className="container">
                    <div className="row justify-content-center">
                        <h2>{t('about.banner5.title')}</h2>
                        <p>{t('about.banner5.description')}</p>
                    </div>
                </div>
            </div>

            <ComingSoon />
            <Footer />
        </>
    );
}

export default AboutPage;